import { render, staticRenderFns } from "./DesignFormIndexToolsModal.vue?vue&type=template&id=627a566a&scoped=true&"
import script from "./DesignFormIndexToolsModal.vue?vue&type=script&lang=js&"
export * from "./DesignFormIndexToolsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627a566a",
  null
  
)

export default component.exports